module.exports = __webpack_public_path__ + "static/media/1.2199113d.jpg";